/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hwaccel_DismissInputs */

const en_hwaccel_dismiss = /** @type {(inputs: Hwaccel_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const fr_hwaccel_dismiss = /** @type {(inputs: Hwaccel_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const ms_sg2_hwaccel_dismiss = /** @type {(inputs: Hwaccel_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Hwaccel_DismissInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const hwaccel_dismiss = /** @type {((inputs?: Hwaccel_DismissInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hwaccel_DismissInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hwaccel_dismiss(inputs)
	if (locale === "fr") return fr_hwaccel_dismiss(inputs)
	return ms_sg2_hwaccel_dismiss(inputs)
});